import { useEffect, useState } from 'react'
import useFetch from './useFetch'
import { urlApi } from '../config'

// La config de rutas (GET /admin/routes) es chica y estática durante la sesión,
// así que la cacheamos a nivel módulo para que Lobbies y Chats no la re-pidan.
let cachedConfig = null

const useRoutesConfig = () => {
  const [config, setConfig] = useState(cachedConfig)
  const { loading, responseOk, data } = useFetch(
    `${urlApi}/admin/routes`,
    undefined,
    { lazy: Boolean(cachedConfig) }
  )

  useEffect(() => {
    if (cachedConfig) return
    if (!loading && responseOk && data && Array.isArray(data.argentina)) {
      cachedConfig = data
      setConfig(data)
    }
  }, [loading, responseOk, data])

  return config || cachedConfig
}

export default useRoutesConfig
